<div class="common-header-container">
  <div class="station-date-container">
    <div class="station-name">
      {{ stationName }}
    </div>
    @if (showStationSelector) {
      <emt-station-selector [airports]="airports"></emt-station-selector>
    }
    @if (showDate) {
      <div class="date-container">
        <span class="date-title">DATE</span>
        <span class="date-value">{{ todaysDate | date: 'MM/dd' }}</span>
      </div>
    }
  </div>

  <div class="tab-options-container">
    <ul class="tab-options-list">
      @for (tabOption of tabOptions; track tabOption) {
        <li class="nav-item" (click)="tabClicked.emit(tabOption)">
          <a class="nav-link" [ngClass]="tabOption.label === activeTab ? 'active' : ''">{{ tabOption.label }}</a>
        </li>
      }
    </ul>
  </div>

  <div class="refresh-container">
    <div class="data-updated-container">
      <span class="refresh-icon" (click)="refreshClicked.emit($event)"></span>
      @if (dataUpdated) {
        <span class="updated-info">Data Updated {{ dataUpdated | date: 'HHmm':'UTC' }}Z</span>
      }
      @if (!dataUpdated) {
        <span class="updated-info">Data Updated N/A</span>
      }
    </div>

    @if (dropdownControl && dropdownOptions) {
      <emt-dropdown-v2
        label="Carrier"
        placeholder="Select Carrier"
        [control]="dropdownControl"
        [optionList]="dropdownOptions"
      ></emt-dropdown-v2>
    }
  </div>
</div>
